module.exports = "/**\n * Function to create an optimized svg url\n */\n/**\n * Replace `$search` with `$replace` in `$string`\n * @author Hugo Giraudel\n * @param {String} $string - Initial string\n * @param {String} $search - Substring to replace\n * @param {String} $replace ('') - New value\n * @return {String} - Updated string\n */\nh2 {\n  color: #3fc5f7; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/education/steps/premedical/question/completed-medical-school-in-usa-screen.component.scss
// module id = 1429
// module chunks = 0